import { adminSeedCollections } from "data/admin/seedData";
import {
  FIREBASE_SYNCED_COLLECTIONS,
  FIRESTORE_COLLECTION_MAP,
  loadFirestoreCollection,
  saveFirestoreChanges,
  saveFirestoreCollection,
  seedFirestoreCollectionIfEmpty,
} from "data/firebase/collectionsApi";
import { isFirebaseConfigured, tryEnsureFirebaseAuth } from "data/firebase";

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

/**
 * Sync list/write API + arka planda Firestore persist.
 * repositoryFactory değişmeden Firebase'e bağlanır.
 */
export function createFirebaseAdminAdapter() {
  const cache = {};
  let hydrated = false;
  let persistChain = Promise.resolve();

  const enqueuePersist = (localName, items, changes) => {
    persistChain = persistChain
      .then(() => (changes ? saveFirestoreChanges(localName, changes) : saveFirestoreCollection(localName, items)))
      .catch((error) => {
        console.warn(`[firebaseAdminAdapter] ${localName} yazılamadı:`, error);
      });
    return persistChain;
  };

  return {
    kind: "firebase",
    label: "Firebase Firestore bağdaştırıcısı",
    collectionMap: FIRESTORE_COLLECTION_MAP,

    isHydrated() {
      return hydrated;
    },

    async hydrate({ seedIfEmpty = true } = {}) {
      if (!isFirebaseConfigured) {
        throw new Error("Firebase yapılandırılmamış");
      }

      await tryEnsureFirebaseAuth();

      for (const name of FIREBASE_SYNCED_COLLECTIONS) {
        let items = await loadFirestoreCollection(name);
        if (seedIfEmpty && !items.length) {
          const seed = adminSeedCollections[name] || [];
          if (seed.length) {
            await seedFirestoreCollectionIfEmpty(name, seed);
            items = await loadFirestoreCollection(name);
          }
        }
        cache[name] = clone(items);
      }

      hydrated = true;
      return cache;
    },

    listCollection(collectionName) {
      if (!hydrated) {
        // hydrate bitmeden çağrılırsa seed fallback (kısa süreli)
        return clone(adminSeedCollections[collectionName] || []);
      }
      if (!(collectionName in cache)) {
        return clone(adminSeedCollections[collectionName] || []);
      }
      return clone(cache[collectionName] || []);
    },

    writeCollection(collectionName, items, changes) {
      if (!FIRESTORE_COLLECTION_MAP[collectionName]) {
        // ads vb. bu adapter dışında
        cache[collectionName] = clone(items);
        return;
      }
      cache[collectionName] = clone(items);
      enqueuePersist(collectionName, cache[collectionName], changes && clone(changes));
    },

    async flush() {
      await persistChain;
    },
  };
}
